import React, { useEffect, useState } from "react";
import clsx from "clsx";
import _ from "lodash";
import CustomEWithdrawHistory from "../../../../src/components/CustomEWithdrawHistory";
import * as axiosInstance from "../../../../src/services/axiosInstance";
import Helper from "../../../../src/utils/Helper";
import { useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import * as StorageManager from "../../../../src/utils/StorageManager";
import constants from "../../../../src/constants";
import * as authSelectors from "../../../../src/selectors/auth";
import ViewDocumentModal from "../../../views/EWithdraw/modal/ViewDocumentModal";
import { getGeneralOptionsContractStatus } from "../../../selectors/general";
import * as generalSelectors from "../../../selectors/general";
import LoadingOverlay from "../../../components/LoadingOverlay";
import SubmittedContractItemModal from "../../ESetOff/SetOff/modal/SubmittedContractItemModal";

function EWithdrawHistory({ generalData }) {
  const [page, setPage] = useState(1);
  const [viewData, setViewData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [status, setStatus] = useState(null);
  const dispatch = useDispatch();
  const [token, setToken] = useState(null);
  const isLogout = useSelector((state) => authSelectors.getAuthIsLogout(state));
  const withdrawStatusOptions = generalSelectors.getGeneralOptionsContractStatus(generalData);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setTokenFunction();
  }, [isLogout]);

  async function setTokenFunction() {
    setToken(await StorageManager.retrieveToken(constants.AUTH_TOKEN));
  }

  const withdrawHistoryData = useQuery({
    queryKey: ["withdrawHistoryList", { page, status, dateFrom, dateTo }],
    queryFn: async () => {
      try {
        const statusQuery = !_.isEmpty(status) ? `&status=${status}` : "";
        const dateQuery =
          !_.isEmpty(dateFrom) && !_.isEmpty(dateTo)
            ? `&created_at_from=${dateFrom}&created_at_to=${dateTo}`
            : "";
        return await axiosInstance.get(`/clientarea/withdraw/list?page=${page}${statusQuery}${dateQuery}`);
      } catch (e) {
        Helper.handleHttpError(e, dispatch);
      }
    },
    retryDelay: 15000,
    enabled:
      !_.isEmpty(token) &&
      ((!_.isEmpty(dateFrom) && !_.isEmpty(dateTo)) || (_.isEmpty(dateFrom) && _.isEmpty(dateTo))),
  });

  const onClickViewPayment = (item) => {
    setViewData(item);
    setShowModal(true);
  };

  const onClickDeleteFunction = async (url) => {
    const confirmed = window.confirm("Are you sure you want to cancel this item?");
    if (!confirmed) {
      return;
    }
    setLoading(true);
    try {
      const result = await axiosInstance.del(`${url}`);
      await withdrawHistoryData.refetch();
      return result;
    } catch (e) {
    } finally {
      setLoading(false);
      setShowModal(false);
    }
  };

  const onClickViewDocument = async (url) => {
    try {
      const res = await fetch(url.replace("http", "https").replace("httpss", "https"), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`, // Here you can set any headers you want
        },
      });
      const blob = await res.blob();

      const urlObject = URL.createObjectURL(blob);
      window.open(urlObject, "_links");
    } catch (e) {
      console.log("ee" + e);
    } finally {
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setViewData(null);
  };

  return (
    <div className="container-fluid">
      <div className={"primary-border-table-border"} style={{ backgroundColor: "white" }}>
        <div className={clsx("custom-card-label-container text-center")}>
          <h2>Withdrawal History</h2>
        </div>
        <div className="transaction-history-container">
          <CustomEWithdrawHistory
            data={withdrawHistoryData}
            page={page}
            setPage={setPage}
            onClickViewPayment={onClickViewPayment}
            viewData={viewData}
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            statusOptions={withdrawStatusOptions}
            statusFilter={status}
            onChangeStatus={(e) => setStatus(e.target.value)}
            dateFrom={dateFrom}
            dateTo={dateTo}
            onChangeDateFrom={(e) => setDateFrom(e.target.value)}
            onChangeDateTo={(e) => setDateTo(e.target.value)}
            onClickDeleteFunction={onClickDeleteFunction}
            loading={loading}
          ></CustomEWithdrawHistory>
        </div>
      </div>
      {/*<ViewDocumentModal*/}
      {/*  show={showModal}*/}
      {/*  handleClose={handleCloseModal}*/}
      {/*  data={viewData}*/}
      {/*  onClickViewDocument={onClickViewDocument}*/}
      {/*  onClickDeleteFunction={onClickDeleteFunction}*/}
      {/*  loading={loading}*/}
      {/*></ViewDocumentModal>*/}

      <SubmittedContractItemModal
          // handleCancel={onClickDeleteFunction}
          handleClose={handleCloseModal}
          show={showModal}
          data={viewData}
          isHideCancel={true}
          onClickDeleteFunction={onClickDeleteFunction}
          loading={loading}
      ></SubmittedContractItemModal>
    </div>
  );
}
export default EWithdrawHistory;
